import type { GetTechnicalSpecificationsResponse } from './technical-specifications'

export const getTechnicalSpecificationsMock: GetTechnicalSpecificationsResponse =
  {
    title: 'iPhone 12 Pro - 128 GB - Pacific Blue - Unlocked',
    warnings: [],
    providedWithProduct: {
      title: 'What’s in the box?',
      texts: [
        'All phones come with a compatible charging cable. To reduce e-waste, AC adapter and headphones are not included.',
      ],
      rows: [
        { icon: 'iphone', text: 'iPhone 12 Pro' },
        { icon: 'charging_cable', text: 'Charging cable' },
      ],
    },
    comesWith: {
      displayAccessoryExclusionsModal: true,
      items: [
        { icon: 'IconHeart', text: 'Good Karma', type: 'good karma' },
        {
          icon: 'IconChargingWire',
          text: 'Charging cable',
          type: 'charging wire',
        },
      ],
    },
    reassurances: [
      {
        title: 'Verified refurbished',
        texts: [
          'Reborn electronics are like new — just better for the planet and your pocket. Our sellers are electronics experts who test and verify that every device is clean and 100% functional before it goes out for delivery. You get what it says on the box or your money back.',
        ],
      },
    ],
    specifications: [
      {
        display: 'Manufacturing part numbers (MPN)',
        field: 'mpn',
        values: [{ label: 'MGLR3LL/A' }],
      },
      {
        display: 'Screen size (inches)',
        field: 'screen_size',
        values: [{ label: '6.1' }],
      },
      { display: 'Color', field: 'color', values: [{ label: 'Pacific Blue' }] },
      {
        display: 'Carrier compatibility',
        field: 'sim_lock',
        values: [{ label: 'Unlocked' }],
      },
      { display: 'Storage', field: 'storage', values: [{ label: '128 GB' }] },
      { display: 'Memory', field: 'memory', values: [{ label: '6 GB' }] },
      {
        display: 'Model',
        field: 'model',
        values: [{ label: 'iPhone 12 Pro' }],
      },
      {
        display: 'Processor brand',
        field: 'processor_brand',
        values: [{ label: 'Apple' }],
      },
      {
        display: 'Processor Core',
        field: 'processor_hearts',
        values: [{ label: '8' }],
      },
      { display: 'Megapixels', field: 'megapixels', values: [{ label: '12' }] },
      { display: 'OS', field: 'os', values: [{ label: 'iOS' }] },
      {
        display: 'Resolution',
        field: 'resolution',
        values: [{ label: '1170 x 2532' }],
      },
      {
        display: 'Screen type',
        field: 'screen_type',
        values: [{ label: 'OLED' }],
      },
      {
        display: 'Connector',
        field: 'connector',
        values: [{ label: 'Lightning' }],
      },
      {
        display: 'Network',
        field: 'network',
        values: [{ label: 'GSM/CDMA + 5G' }],
      },
      {
        display: 'Release Date',
        field: 'date_release',
        values: [{ label: 'October 2020' }],
      },
      { display: 'Double SIM', field: 'double_sim', values: [{ label: 'No' }] },
      {
        display: 'Manufacturer Ref.',
        field: 'manufacturer_version',
        values: [{ label: 'A2341' }],
      },
      {
        display: 'Verizon compatible',
        field: 'verizon_compatible',
        values: [{ label: 'Yes' }],
      },
      {
        display: 'T-Mobile compatible',
        field: 'tmobile_compatible',
        values: [{ label: 'Yes' }],
      },
      {
        display: 'Release Year',
        field: 'year_date_release',
        values: [{ label: '2020' }],
      },
      {
        display: 'Memory Card Slot',
        field: 'card_slot',
        values: [{ label: 'No' }],
      },
      { display: 'Series', field: 'series', values: [{ label: 'iPhone 12' }] },
      { display: 'eSIM', field: 'e_sim', values: [{ label: 'No' }] },
      { display: 'Foldable', field: 'foldable', values: [{ label: 'No' }] },
      { display: '5G', field: '5G', values: [{ label: 'Yes' }] },
      { display: 'SAR head', field: 'sar_head', values: [{ label: '0.99' }] },
      {
        display: 'SIM card',
        field: 'dual_sim',
        values: [{ label: 'Single-SIM' }],
      },
      {
        display: 'SIM format',
        field: 'sim_card_format',
        values: [{ label: 'Nano' }],
      },
      { display: 'Brand', field: 'brand', values: [{ label: 'Apple' }] },
      { display: 'Weight', field: 'weight', values: [{ label: '7 oz' }] },
    ],
    additionalInfo: [
      'Reborn phones are not guaranteed to maintain their waterproof seal.',
    ],
  }
